var map = {
	"./amadeus/MasterDetail.json": 1174,
	"./barclays/MasterDetail.json": 1175,
	"./cb911/MasterDetail.json": 1176,
	"./choiceHotels/MasterDetail.json": 1177,
	"./globex/MasterDetail.json": 1178,
	"./kraken/MasterDetail.json": 1179,
	"./lastminute/MasterDetail.json": 1180,
	"./monavate/MasterDetail.json": 1181,
	"./outpayce/MasterDetail.json": 1182,
	"./sofi/MasterDetail.json": 1183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1173;